import axios from 'axios';
import { ElMessage, ElLoading } from 'element-plus';
import baseURL from '@/configs/config.js';
import { getStorage, removeStorage, setStorage } from "@/utils/storage";
let isShowError = true;
if (process.env && process.env.NODE_ENV != "development") {
  axios.defaults.baseURL = baseURL.apiURL;
}
// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
//lang zh,en,vie
// 请求拦截器
axios.interceptors.request.use(
  config => {
    //文件上传超时时间额外设置
    if (config.url.indexOf('sysGameHotVersion/putZipFile') > -1
      || config.url.indexOf('prizePool/exceptionRequest') > -1
      || config.url.indexOf('admin-report/getGameUserReportPage') > -1
      || config.url.indexOf('admin-report/getGameUserReportStats') > -1) {
      //超时十分钟
      config.timeout = 600000;
    } else {
      config.timeout = 10000;
    }
    const token = getStorage('token') || ''
    //如果是线上环境不走代理，需要把/api删除
    if (process.env && process.env.NODE_ENV != "development") {
      config.url = config.url.replace('/api', '');
    }
    config.headers['lang'] = getStorage('language') || 'zh'
    //登录注册接口不允许带入token
    if (config.url.indexOf('login/token') < 0) {
      token ? config.headers['token'] = 'bearer ' + token : ''
    } else {
      if (config.data.captchaCode) {
        config.headers['captcha-Code'] = config.data.captchaCode
        config.headers['captcha-Key'] = config.data.captchaKey
        config.data = {
          account: config.data.account,
          googleCode: config.data.googleCode,
          password: config.data.password,
          type: config.data.type,
          platformCode: config.data.platformCode
        }
      }
      if (config.data.type == 1) {
        //系统登录
        config.headers['platformCode'] = 'game'
      } else {
        config.headers['platformCode'] = config.data.platformCode
      }
    }
    //登录接口和获取配置接口header传入platformCode
    if (config.url.indexOf('sysParamConfig/list') >= 0) {
      config.headers['platformCode'] = 'game'
    }
    return config;
  },
  error => {
    return Promise.error(error);
  }
);
// 响应拦截器
axios.interceptors.response.use(
  response => {
    removeStorage({ 'name': 'error' })
    if (response.status === 200) {
      if (response.data.code == 20013) {
        if (isShowError) {
          isShowError = false
          ElMessage({
            message: response.data.msg,
            type: 'error',
            onClose: () => {
              isShowError = true
              removeStorage({ 'name': 'token' })
              removeStorage({ 'name': 'selectedTab' })
              setStorage({ name: 'error', content: true })
              window.location.href = "./notAuthority"
            }
          });
        }
      } else if (response.data.code == 20001 || response.data.code == 20014) {
        if (isShowError) {
          isShowError = false
          removeStorage({ 'name': 'token' })
          removeStorage({ 'name': 'selectedTab' })
          ElLoading.service({
            text: ' ',
            background: 'rgba(0, 0, 0, 0)',
            customClass: 'loadingEmpty'
          })
          ElMessage({
            message: response.data.msg,
            // message: 1240043,
            //duration: 200300,
            type: 'error',
            onClose: () => {
              isShowError = true
              window.location.href = "./login"
            }
          });
        }
      } else {
        return Promise.resolve(response);
      }
    } else {
      return Promise.reject(response);
    }
  },
  // 服务器状态码不是200的情况
  error => {
    if (error.response && error.response.data) {
      switch (error.response.data.code) {
        case 20001:
          if (isShowError) {
            isShowError = false
            removeStorage({ 'name': 'token' })
            removeStorage({ 'name': 'selectedTab' })
            ElLoading.service({
              text: ' ',
              background: 'rgba(0, 0, 0, 0)',
              customClass: 'loadingEmpty'
            })
            ElMessage({
              message: error.response.data.msg,
              type: 'error',
              onClose: () => {
                isShowError = true
                window.location.href = "./login"
              }
            });
          }

          break;
        case 500:
          if (error.response.data.msg === "bet status is success") {
            ElMessage({
              message: "状态已是成功！",
              type: "error",
            });
          } else {
            ElMessage({
              message: error.response.data.msg, type: 'error'
            });
          }
          break;
        // 其他错误，直接抛出错误提示
        default:
          ElMessage({
            message: error.response.data.msg, type: 'error'
          });

      }
      return Promise.reject(error.response);
    } else {
      return Promise.reject(error);
    }
  }
);
/**
  * get方法，对应get请求
  * @param {String} url [请求的url地址]
  *
  * @param {Object} params [请求时携带的参数]
  */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      })
  });
}

/**
  * post方法，对应post请求
  * @param {String} url [请求的url地址]
  * @param {Object} params [请求时携带的参数]
  */
export function post(url, data) {
  return new Promise((resolve, reject) => {
    axios.post(url, data)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      })
  });
}

/**
  * post方法，对应post请求
  * @param {String} url [请求的url地址]
  * @param {Object} params [请求时携带的参数]
  */
export function download(url, data) {
  return new Promise((resolve, reject) => {
    axios({
      method: "get",
      url,
      params: data,
      responseType: "blob",
    }).then(res => {
      console.log(res)
      resolve(res.data)
    }).catch(err => {
      reject(err.data)
    })
  })
}
